import { Component } from '@angular/core';
import {NgForOf} from "@angular/common";
import {Router, RouterLink} from "@angular/router";
import {TranslatePipe} from "@ngx-translate/core";

interface FooterItem {
  i18nKey: string;
  path: string;
}

interface FooterSection {
  headingKey: string;
  items: FooterItem[];
}

@Component({
  selector: 'app-footer-card',
  standalone: true,
  templateUrl: './footer-card.component.html',
  imports: [
    NgForOf,
    RouterLink,
    TranslatePipe
  ],
  styleUrls: ['./footer-card.component.scss']
})
export class FooterCardComponent {
  servicesNavs: FooterItem[] = [
    {i18nKey: 'footer.services-digital-transformation', path: '/services#digital-transformation'},
    {i18nKey: 'footer.services-custom-software', path: '/services#custom-software-development'},
    {i18nKey: 'footer.services-cloud-solutions', path: '/services#cloud-solutions'},
    {i18nKey: 'footer.services-ai-automation', path: '/services'}
  ];

  aboutUsNavs: FooterItem[] = [
    {i18nKey: 'footer.about-atrizult', path: '/about'},
    {i18nKey: 'footer.about-clients', path: '/about#our-clients'},
    {i18nKey: 'footer.about-team', path: '/about#our-team'},
    {i18nKey: 'footer.about-career', path: '/about#careers'}
  ];

  projectNavs: FooterItem[] = [
    {i18nKey: 'footer.projects-hps', path: 'https://healthprosuite.com'},
    {i18nKey: 'footer.projects-momh', path: '/about-us#our-clients'},
    {i18nKey: 'footer.projects-enugu-housing', path: '/about-us#our-team'},
  ];

  contactUsNavs: FooterItem[] = [
    {i18nKey: 'footer.contact-free-consultation', path: '/consultation'},
    {i18nKey: 'footer.contact-form', path: '/contact-us'},
    {i18nKey: 'footer.contact-visit-office', path: '/contact-us#visit-our-office'}
  ];

  footerNavRecords = [
    { headingKey: 'footer.services-heading', items: this.servicesNavs },
    { headingKey: 'footer.about-heading', items: this.aboutUsNavs },
    { headingKey: 'footer.projects-heading', items: this.projectNavs },
    { headingKey: 'footer.contact-heading', items: this.contactUsNavs },
  ];

  constructor(private router: Router) {
  }

  onFooterNavClick = (navPath: string) => {
    this.router.navigate([`/${navPath.toLowerCase().replace(/ & /g, '-').replace(/ /g, '-')}`]).then();
  }
}
